import React, { Component } from "react";
import { Table, Button, Col, Tooltip, Row, Modal } from "antd";
import axios from "axios";
import "./Pages.css";
import TituloLiquidarForm from '../components/TituloLiquidarForm';
import TituloFiltroForm from '../components/TituloFiltroForm';
import ResumoCtasPrintModal from "../relatorios/ResumoCtasPrintModal";
import moment from "moment-timezone";
import numeral from "numeral";
import InputForm from "../components/InputForm";
import { maskDate } from "../utils/Masker";

const { Column } = Table;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    formVisivel: false,
    formFiltroVisivel: false,
    formLiqVisivel: false,

    vlrEntradas: 0,
    vlrSaidas: 0,
    vlrSaldo: 0,

    registroParc: [],

    filtros: {
      tipoTela: 'RFC',
      buscaAno: moment().format('YYYY'),
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaControle: '',
      buscaNumero: '',
      buscaDescricao: '',
      buscaTipo: { key: 'X', },
      buscaSituacao: { key: 'X', },
      buscaPessoa: { key: '', },
      buscaPlanoCta: { key: '', },
      buscaCtaCorrente: { key: '', },
      buscaTipoDoc: { key: '', },
    }

  };

  componentDidMount() {
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }


  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true });
    const { pagina, limite } = this.state;

    const { buscaAno } = this.state.filtros;

    if (buscaAno) {
      axios
        .get('/titulos/listaResumoCtas', {
          params: {
            page: pagina,
            limite: limite,
            ano: buscaAno,
            anual: 'S'
          }
        })
        .then(response => {
          this.setState({
            listaRegistros: response.data,
            carregando: false,
          });
        })
        .catch(erro => {
          console.warn(erro);
          this.setState({
            carregando: false,
          });
        });
    } else {
      this.setState({
        listaRegistros: [],
        carregando: false,
      });
    }
  };





  onCancelarLiqClick = () => {
    this.setState({
      formLiqVisivel: false
    })
  }

  onVisualizarClick = registro => {
    this.setState({ carregando: true });
    axios
      .get('/titulos/showParcela', {
        params: {
          idf: registro.tpp_idf,
          parc: registro.tpp_parcela,
        }
      })
      .then(response => {
        const { data } = response;
        data.tipoTela = 'CONS';
        this.setState({
          formLiqVisivel: true,
          registroParc: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { filtros } = this.state;
    filtros[id] = value;
    this.setState({
      [id]: value
    },
      this.getListaRegistros
    );
  };

  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaNumero: String(this.state.filtros.buscaNumero),
        buscaControle: String(this.state.filtros.buscaControle),
        buscaDescricao: String(this.state.filtros.buscaDescricao),
        buscaTipo: this.state.filtros.buscaTipo,
        buscaSituacao: this.state.filtros.buscaSituacao,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaPlanoCta: this.state.filtros.buscaPlanoCta,
        buscaCtaCorrente: this.state.filtros.buscaCtaCorrente,
        buscaTipoDoc: this.state.filtros.buscaTipoDoc,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };






  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }


  renderAcoes = (text, registro) => {
    return (
      <Tooltip title="Visualizar">
        <Button type="ghost" size="small" onClick={() => this.onVisualizarClick(registro)} icon="eye-o" />
      </Tooltip>
    );
  };

  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };




  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, registroParc,
      formFiltroVisivel, formLiqVisivel, filtros, total, pagina, limite,
    } = this.state;

    const { buscaAno, buscaDataIni, buscaDataFim } = this.state.filtros;

    // console.log('CaixasPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Resumo Financeiro por Contas</h2>
        <hr />
        <br />

        <Row>
          <div className="pageFiltro" style={{ height: 20 }}>
            <Col xs={24} >

              <Row xs={24} style={{ marginTop: -20 }}>
                <Col xs={4} style={{ width: 100 }}>
                  <span>Ano</span>
                  <InputForm
                    id="buscaAno"
                    ref="buscaAno"
                    maxLength={4}
                    onChange={this.onChange}
                    value={buscaAno}
                    type="number"
                    decimalScale={0}
                  />
                </Col>

                <Col xs={2} style={{ width: 110, marginTop: 23, marginLeft: 10 }}>
                  <ResumoCtasPrintModal
                    filtros={filtros}
                    ano={this.state.filtros.buscaAno}
                  />
                </Col>

              </Row>
            </Col>

          </div>
        </Row>

        <Row>
          <div style={{ marginTop: 10 }}>
            <Table
              pagination={false}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              rowKey={(registro => registro.pc_idf)}
              scroll={{ x: 600, y: false }}
            >
              <Column
                key="pc_conta"
                dataIndex="pc_conta"
                title="Conta"
                width={80}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="pc_codigo"
                dataIndex="pc_codigo"
                title="Código"
                width={80}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="pc_descricao"
                dataIndex="pc_descricao"
                title="Descrição da Conta"
                width={300}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="vlr01"
                dataIndex="vlr01"
                title="Jan"
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="vlr02"
                dataIndex="vlr02"
                title="Fev"
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="vlr03"
                dataIndex="vlr03"
                title="Mar"
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="vlr04"
                dataIndex="vlr04"
                title="Abr"
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="vlr05"
                dataIndex="vlr05"
                title="Mai"
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="vlr06"
                dataIndex="vlr06"
                title="Jun"
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="vlr07"
                dataIndex="vlr07"
                title="Jul"
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="vlr08"
                dataIndex="vlr08"
                title="Ago"
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="vlr09"
                dataIndex="vlr09"
                title="Set"
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="vlr10"
                dataIndex="vlr10"
                title="Out"
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="vlr11"
                dataIndex="vlr11"
                title="Nov"
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="vlr12"
                dataIndex="vlr12"
                title="Dez"
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
            </Table>
          </div>
        </Row>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/ResumoCtasPage.js